import React, {useState, useEffect} from 'react'
import { getDepartments } from './api'
import { getUsersDepartments, CheckUser } from './checkUser'


let selected = {
  department: '',
  category: 'All'
}

export const GetSelected = () => {
  return {
    selected
  }
}

export const SetSelectedDepartment = (dep) => {
  selected.department = dep;
  selected.category = "All";
}

export const SetSelectedCategory = (cat) => {
  selected.category = cat;
}

